if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.quantity__input');
      this.currentVariant = this.querySelector('.product-variant-id');
      this.variantSelects = this.querySelector('variant-radios')
      this.submitButton = this.querySelector('[type="submit"]');
    }

    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;

    connectedCallback() {
      //3348
      console.log("initColorHoverPreview");
      this.initColorHoverPreview();
      this.updateSizeMatrixVariantIds();
      //3348
      if (!this.input) return;
      this.quantityForm = this.querySelector('.product-form__quantity');
      if (!this.quantityForm) return;
      this.setQuantityBoundries();  
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        if (event.data.sectionId !== sectionId) return;
        this.updateQuantityRules(event.data.sectionId, event.data.html);
        this.setQuantityBoundries();
        this.updateSizeMatrixVariantIds();
      });
      //3348
      // console.log("initColorHoverPreview");
      // this.initColorHoverPreview();
      //3348
    }
    //3348
    initColorHoverPreview() {
  const colorFieldset = this.querySelector('.product-form__input--swatch.Color');
  console.log("colorFieldset",colorFieldset);
  if (!colorFieldset) return;

  const valueLabel = colorFieldset.querySelector('[data-selected-value]');
  if (!valueLabel) return;

  let selectedColor = valueLabel.textContent.trim();

  const bind = () => {
    colorFieldset.querySelectorAll('[data-color-name]').forEach((swatch) => {
      if (swatch.dataset.bound === '1') return;
      swatch.dataset.bound = '1';

      const colorName = swatch.dataset.colorName;

      swatch.addEventListener('mouseenter', () => {
        valueLabel.textContent = colorName;
      });

      swatch.addEventListener('mouseleave', () => {
        valueLabel.textContent = selectedColor;
      });

      swatch.addEventListener('click', () => {
        selectedColor = colorName;
        valueLabel.textContent = selectedColor;
      });
    });
  };

  bind();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      selectedColor = valueLabel.textContent.trim();
      bind();
    });
  }
}

updateSizeMatrixVariantIds() {
  const matrix = this.querySelector('.size-matrix');
  if (!matrix) return;
  
this.querySelectorAll('.size-qty-input').forEach(input => {
  input.value = 0;
});
  const sizeIndex = parseInt(matrix.dataset.sizeOptionIndex, 10);
  if (Number.isNaN(sizeIndex)) return;

  // Current selected variant id (this changes when you click swatches)
  const currentVariantId = parseInt(this.currentVariant?.value, 10);
  if (!currentVariantId) return;

  // Get variants JSON from the variant picker (Dawn/Modista pattern)
  const variantsScript =
    this.querySelector('variant-radios script[type="application/json"], variant-selects script[type="application/json"]');

  if (!variantsScript) return;

  let variants;
  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch (e) {
    console.error('Unable to parse variants JSON', e);
    return;
  }

  const selectedVariant = variants.find(v => v.id === currentVariantId);
  console.log("selectedVariant => ",selectedVariant);
  if (!selectedVariant) return;

  this.querySelectorAll('.size-qty-input').forEach(input => {
    const sizeValue = input.dataset.size;
    if (!sizeValue) return;

    const match = variants.find(v => {
      // match all options except size
      for (let i = 0; i < v.options.length; i++) {
        if (i === sizeIndex) continue;
        if (v.options[i] !== selectedVariant.options[i]) return false;
      }
      // match size
      return v.options[sizeIndex] === sizeValue;
    });

    if (match) input.dataset.variantId = match.id;
  });
}




    //3348

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    setQuantityBoundries() {
      const data = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      }

      let min = data.min;
      const max = data.max === null ? data.max : data.max - data.cartQuantity;
      if (max !== null) min = Math.min(min, max);
      if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

      this.input.min = min;
      this.input.max = max;
      this.input.value = min;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);  
    }

    fetchQuantityRules() {
      if (!this.currentVariant || !this.currentVariant.value) return;
      this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
      fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`).then((response) => {
        return response.text()
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.updateQuantityRules(this.dataset.section, html);
        this.setQuantityBoundries();
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
      });
    }

    updateQuantityRules(sectionId, html) {
      const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
      const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
      for (let selector of selectors) { 
        const current = this.quantityForm.querySelector(selector);
        const updated = quantityFormUpdated.querySelector(selector);
        if (!current || !updated) continue;
        if (selector === '.quantity__input') {
          const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
          for (let attribute of attributes) {
            const valueUpdated = updated.getAttribute(attribute);
            if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
          }
        } else {
          current.innerHTML = updated.innerHTML;
        }
      }
    }


  }
)};


